// Palette condivisa da dashboard pubblicazione e statistiche degli articoli.
export const PUBLISH_STATUS_COLORS = {
  SI: "#2e7d32",
  "DA CONTROLLARE": "#a5d6a7",
  NO: "#cfd8dc",
  PROBLEMA: "#ef6c00",
  "NON PUBBLICARE": "#424242",
  ALTRO: "#607d8b",
};

export const PUBBLICATO_ID_TO_LABEL = {
  180979: "SI",
  180978: "NO",
  201530: "NON PUBBLICARE",
  284425: "PROBLEMA",
};

export function publicationLabelFromValue(value) {
  const selected = PUBBLICATO_ID_TO_LABEL[String(value?.valueId ?? "").trim()];
  if (selected) return selected;
  const description = String(value?.valueDesc ?? "").trim().toUpperCase();
  return description || null;
}

export function publicationSelectionFromValue(value) {
  const label = publicationLabelFromValue(value);
  const legacyId = Object.keys(PUBBLICATO_ID_TO_LABEL).find(id => PUBBLICATO_ID_TO_LABEL[id] === label);
  return legacyId ?? (label === "DA CONTROLLARE" ? label : value?.valueId ?? value?.valueDesc ?? "");
}

// I valori storici conservano gli ID; i nuovi valori sono testuali per Tembo.
export function publicationValueFromSelection(value) {
  return value === "DA CONTROLLARE"
    ? { valueDesc: value }
    : { valueId: value === "" ? null : Number(value) };
}
